module.exports = __webpack_public_path__ + "static/bl-3-df452f5e25f6db5962207a5558497070.png";